import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {FieldType, MemberAddeditComponent, MemberAddeditDialogModel} from '../../brokeragency/member-addedit/member-addedit.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VendorsService } from '../../../services/vendors/vendors.service';
import { UiAlertService } from '../../../services/ui-alert/ui-alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SpinnerService } from '../../../services/spinner/spinner.service';


@Component({
  selector: 'app-vendors-page',
  templateUrl: './vendors-page.component.html',
  styleUrls: ['./vendors-page.component.scss']
})
export class VendorsPageComponent implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;

  protected allColumnNames = ['vendorSlug', 'actionmenu'];
  protected items = new MatTableDataSource<any>();

  private addEditFields = [
    {name: 'vendorSlug', label: 'Vendor slug', fieldType: FieldType.F_STRING, required: true},
    {name: 'config', label: 'Config JSON', fieldType: FieldType.F_JSON, required: false},
    {name: 'metadata', label: 'Metadata JSON', fieldType: FieldType.F_JSON, required: false},
    {name: 'schedules', label: 'Schedules JSON', fieldType: FieldType.F_JSON, required: false},
  ];

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
    private uiAlertService: UiAlertService,
    private vendorsService: VendorsService,
  ) {}

  ngOnInit(): void {
    this.reloadItems();
  }

  addItem(baseData?: Record<string, any>): void {
    const newVendorConfigData: Record<string, any> = baseData ? structuredClone(baseData.plain()) : {};
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(newVendorConfigData, this.addEditFields, 'New Vendor Config')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        // Update values in item before PUTing to API
        for (const key of Object.keys(dialogResult)) {
          newVendorConfigData[key] = dialogResult[key];
        }
        this.vendorsService.createVendor(newVendorConfigData).then(() => {
          this.reloadItems();
          this.snackBar.open('Vendor config created', 'Close', {
            duration: 3000
          });
        });
      }
    });
  }

  deleteItem(item: any): void {
    this.uiAlertService.presentAlertConfirm('Are you sure you want to delete this vendor config?').then(async confirm => {
      if (confirm) {
        this.spinnerService.show('Deleting vendor config...');
        this.vendorsService.deleteVendor(item.id).then(() => {
          this.reloadItems();
          this.spinnerService.hide();
          this.snackBar.open('Vendor config deleted', 'Close', {
            duration: 3000
          });
        }).catch((err: HttpErrorResponse) => {
          this.spinnerService.hide();
          this.snackBar.open('Unable to delete vendor config', 'Close', {
            duration: 3000
          });
        });
      }
    });
  }

  editItem(item: any): void {
    const dialogRef = this.dialog.open(MemberAddeditComponent, {
      data: new MemberAddeditDialogModel(item, this.addEditFields, 'Vendor Config')
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        // Update values in item before PUTing to API
        for (const key of Object.keys(dialogResult)) {
          item[key] = dialogResult[key];
        }
        this.vendorsService.updateVendor(item.id, item).then(() => {
          this.reloadItems();
          this.snackBar.open('Vendor config updated', 'Close', {
            duration: 3000
          });
        });
      }
    });
  }

  private reloadItems(): void {
    this.vendorsService.getAllVendors().then(vendors => {
      // Default to alphabetical sort
      this.items.data = vendors.sort((vendor1, vendor2) => vendor1.vendorSlug > vendor2.vendorSlug ? 1 : -1);
      this.items.sort = this.sort;
    });
  }
}
